import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import Header from "../../../shared/layout/Header";
import BottomFooter from "../../../shared/layout/BottomFooter";
import CartSection from "../components/CartSection";
import ScrollToTop from "react-scroll-to-top";
import { CartProvider } from "../context/CartContext";
import Footer from "../../../shared/layout/Footer";

const CartPage = () => {
  return (
    <CartProvider>
      <ColorInit color={'bigmall'} />

      <ScrollToTop smooth color="#ef253c" />

      <Header />

<div className="container container-lg">
      <CartSection />
</div>

      <Footer />

      <BottomFooter />
    </CartProvider>
  );
};

export default CartPage;
